/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlIgnoredFindingsResult } from './ControlIgnoredFindingsResult';
import {
    ControlIgnoredFindingsResultFromJSON,
    ControlIgnoredFindingsResultFromJSONTyped,
    ControlIgnoredFindingsResultToJSON,
} from './ControlIgnoredFindingsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedIgnoredFindingsResponse
 */
export interface ControlPaginatedIgnoredFindingsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedIgnoredFindingsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedIgnoredFindingsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedIgnoredFindingsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlIgnoredFindingsResult>}
     * @memberof ControlPaginatedIgnoredFindingsResponse
     */
    results: Array<ControlIgnoredFindingsResult>;
}

/**
 * Check if a given object implements the ControlPaginatedIgnoredFindingsResponse interface.
 */
export function instanceOfControlPaginatedIgnoredFindingsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedIgnoredFindingsResponseFromJSON(json: any): ControlPaginatedIgnoredFindingsResponse {
    return ControlPaginatedIgnoredFindingsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedIgnoredFindingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedIgnoredFindingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlIgnoredFindingsResultFromJSON)),
    };
}

export function ControlPaginatedIgnoredFindingsResponseToJSON(value?: ControlPaginatedIgnoredFindingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlIgnoredFindingsResultToJSON)),
    };
}

